<template>
  <div class="d-flex flex-column">
    <div class="filter-component-container d-flex align-center flex-fill mb-2">
      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Asignatura
        </span>     
        <v-select
          dense
          v-model="subject"
          :items="user.subjects"
          placeholder="Asignatura"
          outlined
          hide-details="auto"
          :item-text="item => capitalizeFirstLetter(item.name)"
          :item-value="item => item.subjectId"
        ></v-select>
      </div>

      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Estado
        </span>   
        <v-select
            dense
            v-model="estado"
            :items="this.estados"
            placeholder="Estado"
            outlined
            hide-details="auto"
            :item-text="item => item.name"
            :item-value="item => item.id"
        ></v-select>
      </div>

       <div class="ml-2 mt-auto m-basis-90 d-flex justify-content-end">
        <v-btn dark class="primary-btn text-capitalize text-center" @click="search()" height='40px'>
          <v-icon> mdi-magnify </v-icon>
          <span class="hide-sm">Buscar</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import GroupSelect from "@/components/commons/RomaGroupSelect";
import Utility from "@/mixins/Utility";


export default {
  components: {},
  mixins: [Utility],
  data() {
    return {
      title: "",
      code: "",
      pie: false,
      description: ``,
      subject: "",
      level: "",
      cource: "",
      unit: "",
      planUnit: "",
      activity: "",
      week: "",
      dialog: false,
      estado:"",
	    estados : [{id:'POR_ENVIAR',name:'POR ENVIAR'},{id:'PENDIENTE',name:'ENVIADO'},{id:'REVISADO',name:'EVALUADO'}],
      sectionsItems: [],
      subjectListFiltered:[],
      // validations
      requiredRules: [v => !!v || "Este campo es requerido"],
      editorIsEmpty: false
    };
  },
  mounted() {
			this.filterStudentSubjects();
	},
  computed: {
    ...mapGetters({
      lessonInfo: "getLessonInformation",
      user: "getUserData",
    }),
    // availableSubmit() {
    //     const availableSubmit =
    //         !!this.title &&
    //         !!this.code &&
    //         !!this.description &&
    //         !!this.subject &&
    //         !!this.level &&
    //         !!this.cource &&
    //         !!this.unit;

    //     // &&
    //     // !!this.planUnit &&
    //     // !!this.activity &&
    //     // !!this.week;

    //     return availableSubmit;
    // },
    // avalibleUpdate() {
    //     const avalibleUpdate =
    //         this.title === this.getLesson.title &&
    //         this.code === this.getLesson.code &&
    //         this.description === "" &&
    //         this.level === "" &&
    //         this.cource === this.getLesson.section.sectionId &&
    //         this.subject === this.getLesson.subject.name &&
    //         this.unit === this.getLesson.unit.unitId;
    //     return avalibleUpdate;
    // },
    currentSubject() {
      const subjectList = this.lessonInfo.subjectList
        ? this.lessonInfo.subjectList
        : [];
      const currentSubject = subjectList.filter(subject => {
        return subject.name === this.subject;
      });
      return currentSubject;
    },
    currentEducations() {
      const educations = this.currentSubject[0]
        ? this.currentSubject[0].educations
        : [];

      // deconstruct Educations
      const newArr = [];
      educations.forEach(item => {
        newArr.push({
          header: item.name
        });
        item.categories.forEach(category => {
          newArr.push(category);
        });
        newArr.push({ divider: true });
      });
      return newArr;
    },
    currentSubjectList() {
      return this.lessonInfo ? this.lessonInfo.subjectList : [];
    },
    currentInstitutionId() {
      return this.user && this.user.institutionContext
        ? this.user.institutionContext.institutionId
        : [];
    }
  },
  methods: {
    ...mapActions({
            actionGetTasks: "actionGetTasks"
        }),
    setNivel(level) {
      this.level = level;
    },
    search() {
            const sectionId = this.cource ? `&sectionId=${this.cource}` : "";
            const subjectId = this.subject
                ? `&subjectId=${this.subject}`
                : "";
			const estado = this.estado ? `&state=${this.estado}` : "";
            // const level = this.level ? `categoryId=${this.level}` : "";
            // const institutionId = this.user.institutionContext.institutionId
            //     ? `&institutionId=${this.user.institutionContext.institutionId}`
            //     : "";
            // const personId = this.user.personId
            //     ? `&personId=${this.user.personId}`
            //     : "";
            // const unitId = this.unit ? `&unitId=${this.unit}` : "";
            // const title = this.searchText ? `&title=${this.searchText}` : "";

            const query = `${sectionId}${subjectId}${estado}`;
            this.actionGetTasks({
                searchQuery: query,
                pageNumber: 0,
                pageSize: 8
            });
        },
        filterStudentSubjects(){
            const sectionId = this.user.section.sectionId;
            console.log("course (section id) Selected:",sectionId);
            this.subjectListFiltered = [];
            this.lessonInfo.subjectList.forEach(subject => {
                let aux = false;
                subject.educations.forEach( education => {
                    education.categories.forEach( category => {
                            category.sections.forEach( section => {
                                if(section.sectionId == sectionId){
                                    aux = true;
                                }
                            });
                    });
                });

                if(aux === true ){
                    this.subjectListFiltered.push(subject);
                }

            });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";
@import '../../assets/styles/generals.scss';

.task_filter_container {
  width: 100%;
  margin-top: 1rem;
  padding-bottom: 0%;
  background: #ffffff;
  border-radius: 5px;
  //   padding: 1rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
